// extracted by mini-css-extract-plugin
export var button = "_k9-2";
export var card = "_k9-0";
export var closeButtonContainer = "_k9-3";
export var iconContainer = "_k9-1";